import React from "react";
import { Styled } from "./styles";
import { MenuItem, Select, Typography } from "@mui/material";
import { i18n } from "@/utils/i18n";
import { Controller, useFormContext } from "react-hook-form";
import { Forms } from "@/types/form";

interface Props {
    index: number;
    variant: "incomings" | "outgoings" | "accounts" | "assets" | "debts";
}

const Status: React.FC<Props> = ({ index, variant }) => {
    const { control } = useFormContext<Forms["Report"]>();

    return (
        <Styled.FormControl fullWidth={false}>
            <Controller
                name={`${variant}.${index}.status`}
                control={control}
                render={({ field }) => (
                    <Select
                        {...field}
                        id="transaction-status-select"
                        renderValue={value => {
                            return value === 1 ? (
                                <Typography color="primary" fontSize={22}>
                                    &#10004;
                                </Typography>
                            ) : value === 2 ? (
                                <Typography
                                    color="primary"
                                    fontSize={22}
                                    sx={{ ":after": { content: '"*"' } }}
                                >
                                    &#10004;
                                </Typography>
                            ) : value === 3 ? (
                                <Typography color="primary" fontSize={34}>
                                    &#8764;
                                </Typography>
                            ) : (
                                <Typography color="primary" fontSize={34}>
                                    &#8722;
                                </Typography>
                            );
                        }}
                    >
                        <MenuItem value={0}>
                            <Typography variant="subtitle1">
                                {i18n.t("categoryStatus.0")}
                            </Typography>
                        </MenuItem>
                        <MenuItem value={1}>
                            <Typography variant="subtitle1">
                                {i18n.t("categoryStatus.1")}
                            </Typography>
                        </MenuItem>
                        <MenuItem value={2}>
                            <Typography variant="subtitle1">
                                {i18n.t("categoryStatus.2")}
                            </Typography>
                        </MenuItem>
                        <MenuItem value={3}>
                            <Typography variant="subtitle1">
                                {i18n.t("categoryStatus.3")}
                            </Typography>
                        </MenuItem>
                    </Select>
                )}
            />
        </Styled.FormControl>
    );
};

export default Status;
